import angular from 'angular';

class DeviceConfigIndexItem {
  constructor($state) {
    'ngInject';

    this.$state = $state;

    this.restrict = 'E';
    this.replace = true;
    this.template = require('./device-index-item.html');
    this.scope = {
      device: '=',
      linkState: '=',
      oem: '=',
      secondIndent: '=',
    }
  }

  link(scope) {
    let baseState = 'main';
    if (scope.oem) {
      baseState = 'oem_main';
    }

    if (!scope.secondIndent) {
      scope.style = {width: '100%', padding: '12px 0'}
    }

    const stateParams = {id: scope.device.id, company_id: scope.device.company_id};
    let stateName = '';

    if (scope.device.operating_mode === 'reading') {
      scope.iconClass = 'fa-tachometer-alt';
      stateName = scope.linkState || `${baseState}.device_config_edit`;
    } else {
      scope.iconClass = 'fa-sliders-h';
      stateName = scope.linkState || `${baseState}.controller_device_edit`;
    }

    scope.href = this.$state.href(stateName, stateParams);
  }
}

export default angular.module('leptonApp.configIndexItem', [])
  .directive('configIndexItem', ['$state', ($state) => new DeviceConfigIndexItem($state)])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/device-index-item/device-index-item.directive.js